// Constants
import TASKS from './tasks'

const MINIMUM_NOTES_COUNT = 5

const INITIAL_GETTING_STARTED_DETAILS = {
  enabled: undefined,
  tasks: TASKS
}

export {
  MINIMUM_NOTES_COUNT,
  INITIAL_GETTING_STARTED_DETAILS
}
